import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=425059ed"
import script from "./Attachments.ts?vue&type=script&lang=ts&external"
export * from "./Attachments.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports